import { render, staticRenderFns } from "./qwLeads.vue?vue&type=template&id=edf05ac4&scoped=true"
import script from "./qwLeads.vue?vue&type=script&lang=js"
export * from "./qwLeads.vue?vue&type=script&lang=js"
import style0 from "./qwLeads.vue?vue&type=style&index=0&id=edf05ac4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf05ac4",
  null
  
)

export default component.exports